var map = {
	"./character-disappointed.svg": [
		3793,
		1609
	],
	"./character-embarrassed.svg": [
		3794,
		1608
	],
	"./character-greedy.svg": [
		3795,
		1607
	],
	"./character-happy.svg": [
		3796,
		1606
	],
	"./character-sad.svg": [
		3797,
		1605
	],
	"./character-searching.svg": [
		3798,
		1604
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2191;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img lazy ^\.\/character\-.*\.svg$
// module id = 2191
// module chunks = 1611